module.exports = __webpack_public_path__ + "static/media/Tasso_Lockup_ha.e82a84e6.svg";